var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-photo"},[_c('b-link',{attrs:{"to":{
      name: "influencer.profile-page",
      params: {
        id: _vm.user.influencer_uid,
        username: _vm.user.username,
      },
    }}},[_c('UserAvatar',{attrs:{"photo-url":_vm.user.profile_photo_url}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }